module.exports = __webpack_public_path__ + "img/bg6.f53794b9.jpg";